module.exports = __webpack_public_path__ + "img/logocentumx.fed9503f.png";